<template>
  <div class="bg-light">
    <b-container class="text-center py-3">
      <span class="text-muted">
        &copy; ZoopLocal {{ currentYear }}. All rights reserved.
      </span>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'CopyrightBar',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>
